import { render, staticRenderFns } from "./OtherCompanyBankProducts.vue?vue&type=template&id=aadfe6f2&scoped=true&"
import script from "./OtherCompanyBankProducts.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyBankProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadfe6f2",
  null
  
)

export default component.exports